<template>
    <KillerHudBrackets>
        <h1
            ref="title"
            class="font-title max-w-[230px] text-center text-[36px] leading-[37px] font-black text-balance text-white uppercase"
            :style="{ width: textWidth ? `${textWidth}px` : null }"
        >
            <slot />
        </h1>
    </KillerHudBrackets>
</template>

<script>
import KillerHudBrackets from '../ui/KillerHudBrackets.vue'

export default {
    name: 'KillerSplashTitle',
    components: { KillerHudBrackets },
    data() {
        return {
            textWidth: null,
        }
    },
    async mounted() {
        await document.fonts?.ready
        this.fitToText()
    },
    methods: {
        fitToText() {
            const title = this.$refs.title
            if (!title) return

            const range = document.createRange()
            range.selectNodeContents(title)
            const lineWidths = [...range.getClientRects()].map((rect) => rect.width)
            const renderScale = title.getBoundingClientRect().width / title.offsetWidth
            if (!lineWidths.length || !renderScale) return

            const width = Math.ceil(Math.max(...lineWidths) / renderScale)
            if (width < title.offsetWidth) this.textWidth = width
        },
    },
}
</script>
